import { chartTableFlatTransformer } from '../chartTableFlatTransformer';

// Stage map for live job pipeline - uses _actual_count keys
const stageMap = {
  application_review_actual_count: 'Application review',
  interviews_actual_count: 'Interviews',
  offer_actual_count: 'Offer',
  hired_actual_count: 'Hired',
};

/**
 * Transforms the API response into data formatted for charting.
 * Uses _actual_count keys for live job pipeline (current snapshot).
 */
export const liveJobPipelineChartTransformer = ({ response }) => {
  const { chart = [], headers, lookups, misc } = response || {};
  const { stage_mapping } = misc || {};
  const { dt, g1, g2 } = lookups || {};

  const transformedData = chartTableFlatTransformer({
    headers,
    data: chart,
    g1,
    g2,
    dt,
  });

  const stageKeys = stage_mapping
    ? Object.keys(stage_mapping).map((key, idx) => `s${idx + 1}_actual_count`)
    : Object.keys(stageMap);

  const stageLabels = stage_mapping
    ? Object.values(stage_mapping)
    : Object.values(stageMap);

  const seriesData = Array(stageKeys.length).fill(0);

  transformedData.forEach((datum) => {
    stageKeys.forEach((key, idx) => {
      seriesData[idx] += parseInt(datum[key], 10) || 0;
    });
  });

  const series = stageLabels.map((label: string, idx) => {
    const defaultKeyMap = {
      Interviews: 'interviews_actual_count',
      Offer: 'offer_actual_count',
    };

    return {
      name: label,
      y: seriesData[idx],
      custom_id: stage_mapping
        ? `s${idx + 1}_actual_count`
        : defaultKeyMap[label] || label,
    };
  });
  const categories = stageLabels;

  return {
    categories,
    series,
  };
};
